<template>
  <div class="bg">
    <div class="bg_top">
      <div class="top_content">
        <div class="time_content">
          <div class="hour">{{ dateObj.timeString }}</div>
          <div class="date_box">
            <div class="week">{{ dateObj.weekString }}</div>
            <div class="date">{{ dateObj.dateString }}</div>
          </div>
        </div>
        <div class="title_content"></div>
      </div>
    </div>
    <div :class="['bg_left', tapIndex == 8 ? 'hidden' : '']" ref="leftDom"></div>
    <div :class="['bg_right', tapIndex == 8 ? 'hidden' : '']" ref="rightDom"></div>
    <div class="bg_bottom">
      <div :class="['bottom_content']">
        <div :class="['bg_' + pageIndex]"></div>
        <div class="btn_content">
          <div
            :class="['item', pageIndex === index ? 'active' : '']"
            v-for="(item, index) in routerArr"
            :key="index"
            @click="changePage(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick, reactive, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useOverViewStore } from '@/store/index';
import { storeToRefs } from 'pinia';
import { isSwitch } from '@/util/config';
import AiCore from '@/components/AiCore/ai-core.vue';
import { clientWidth, clientHeight, isAdapt, isPeerStream, ueServer } from '@/util/config';

const store = useOverViewStore();
const router = useRouter();

const { pageIndex, tapIndex } = storeToRefs(store);
let timer = null;

let dateObj = ref({
  dateString: null,
  timeString: null,
  weekString: null,
});

let routerArr = reactive([
  {
    name: '综合态势',
    router: '/index/situation',
  },
  {
    name: '安全态势',
    router: '/index/safe',
  },
  {
    name: '能源态势',
    router: '/index/industry',
  },
  {
    name: '运营态势',
    router: '/index/operation',
  },
]);

const changePage = (index) => {
  if (pageIndex.value !== index) {
    router.push({
      path: routerArr[index].router,
    });

    if (isSwitch) {
      changeAni();
    }
  }
};

const getTime = () => {
  const date = new Date();
  let dateString =
    date.getFullYear() +
    '.' +
    (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
    '.' +
    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  let timeString =
    date.getHours() + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());

  let weekString = '星期' + '日一二三四五六'.charAt(date.getDay());

  // console.log(dateString, timeString, weekString);
  dateObj.value.dateString = dateString;
  dateObj.value.timeString = timeString;
  dateObj.value.weekString = weekString;
};

const startTimer = () => {
  clearInterval(timer);
  timer = null;
  timer = setInterval(() => {
    getTime();
  }, 1000);
};

const leftDom = ref(null);
const rightDom = ref(null);
let leftWidth = ref(null);
let rightWidth = ref(null);
let timeOut = ref(null);

const changeAni = () => {
  leftDom.value.style.left = `-${leftWidth.value}px`;
  rightDom.value.style.left = `${clientWidth + 20}px`;
  leftDom.value.style.transition = `left 0s`;
  rightDom.value.style.transition = `left 0s`;

  timeOut.value = setTimeout(() => {
    rightDom.value.style.transition = `left 0.8s`;
    rightDom.value.style.left = `${clientWidth - rightWidth.value}px`;
    leftDom.value.style.transition = `left 0.8s`;
    leftDom.value.style.left = `0px`;
  }, 300);
};

watch(
  () => pageIndex.value,
  (newValue) => {},
  { immediate: true }
);
onMounted(() => {
  startTimer();
  nextTick(() => {
    if (leftDom.value && rightDom.value) {
      leftWidth.value = leftDom.value.offsetWidth + 10;
      rightWidth.value = rightDom.value.offsetWidth;
      leftDom.value.style.transition = `left 0.5s`;
      rightDom.value.style.transition = `left 0.5s`;
    }
  });
});

onBeforeUnmount(() => {
  clearInterval(timer);
  timer = null;
});
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
